import { siteSettingsActions } from '../../services';

export const siteSettingsDispatcher = dispatch => ( {
  get: () => dispatch( { type: siteSettingsActions.GET } ),
  changeSiteSettings: data => dispatch( { type: siteSettingsActions.LOAD, data } )
} );
